export const GET_DATA = 'GET_DATA'
export const SET_DATA = 'SET_DATA'
